import React, { useEffect, useMemo } from "react";
import clsx from "clsx";
import { Avatar, Box, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { listProjectLabel } from "actions/projectLabels/listProjectLabels";
import {
  CellLabelCustom,
  CellPriorityCustom,
  CellStatusCustom,
} from "views/ProjectGroupPage/RightPart/AllProjectTable/constants/Columns";
import "./styles.scss";

// Some override style of google material components
const useStyles = makeStyles({
  wrapRowAvatar: {
    paddingBottom: "0 !important",
  },
  smallAvatar: { width: 25, height: 25 },
});

const renderAvatars = (props) => {
  const { images = [] } = props;
  let showImages = images;
  const imgNum = 3;
  const plusImage = images.length - imgNum;
  if (plusImage > 0) {
    showImages = images.slice(0, imgNum);
  }
  return (
    <div className={`wrap-avatars wrap-avatars-${showImages.length}`}>
      {showImages.map(({ avatar }, i) => (
        <Avatar
          key={i}
          className={clsx(
            `chat_tab_header--avatar${showImages.length}_${i + 1}`,
            {
              [`chat_tab_header--avatar${showImages.length}_${i + 1}_plus`]:
                plusImage > 0,
            }
          )}
          src={avatar}
        />
      ))}
      {plusImage > 0 && (
        <Avatar className="chat_tab_header--avatar_plus">{`+${plusImage}`}</Avatar>
      )}
    </div>
  );
};

function TabHeader({ openEditLabel = () => {} }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const project = useSelector(
    (state) => state.project.detailProject.data.project
  );
  const projectMembers = useSelector(
    (state) => state.project.memberProject.data.membersAdded || []
  );
  const [hovering, setHovering] = React.useState(false);

  useEffect(() => {
    dispatch(listProjectLabel());
  }, []);

  return (
    <div
      className="chat_tab_header"
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      {renderAvatars({ styles: classes, images: projectMembers })}
      <div className="chat_tab_header--task_name">{project?.name}</div>
      {project && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 20,
          }}
        >
          <CellLabelCustom
            props={project}
            hovering={hovering}
            setHovering={setHovering}
            onEdit={openEditLabel}
            isShared={false}
          />
          <CellPriorityCustom
            props={project}
            hovering={hovering}
            setHovering={setHovering}
            isShared={false}
          />
          <CellStatusCustom props={project} />
        </Box>
      )}
    </div>
  );
}

export default TabHeader;
